//文字コードはutf-8

// ハンバーガーメニュー
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initHamburgerMenu() {
  const menu = document.querySelectorAll('.header__nav');
  const openBtn = document.querySelectorAll('.header__btn');
  const inner = document.querySelectorAll('.header__inner');
  const navInner = document.querySelectorAll('.header__nav__inner');
  const mq = window.matchMedia(MEDIA_QUERIES.smartphone);

  // aria-expandedとaria-labelを更新する関数
  function updateAriaAttributes(isOpen) {
    $(openBtn).each(function() {
      const btn = this;
      const textSpan = btn.querySelector('.text');
      if (isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'メニューを閉じる');
        if (textSpan) {
          textSpan.textContent = 'CLOSE';
        }
      } else {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'メニューを開く');
        if (textSpan) {
          textSpan.textContent = 'MENU';
        }
      }
    });
  }

  // スクロール時にheader__innerを非表示にする関数
  function handleNavInnerScroll() {
    $(navInner).each(function() {
      const navInnerEl = this;
      
      $(navInnerEl).off('scroll.headerInner').on('scroll.headerInner', function() {
        const scrollTop = navInnerEl.scrollTop;
        if (scrollTop >= 30) {
          $(inner).addClass('is-scrolled');
        } else {
          $(inner).removeClass('is-scrolled');
        }
      });
    });
  }

  // ページが読み込まれた時に実行
  handle(mq);

  function handle(mm) {
    $(function () {
      $(openBtn).off('click.hamburger').on('click.hamburger', function () {
        const logo = document.querySelector('.header__logo');
        if ($(openBtn).hasClass('is-active')) {
          $(openBtn).removeClass('is-active');
          $(menu).removeClass('is-open');
          document.body.classList.remove('scrollLock');
          $(inner).removeClass('is-scrolled');
          updateAriaAttributes(false);
          // メニューを閉じたときは、スクロール位置に応じてロゴの表示を制御
          if (logo) {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop >= 30) {
              logo.classList.add('is-hidden');
            } else {
              logo.classList.remove('is-hidden');
            }
          }
        } else {
          $(openBtn).addClass('is-active');
          $(menu).addClass('is-open');
          document.body.classList.add('scrollLock');
          updateAriaAttributes(true);
          handleNavInnerScroll();
          // メニューを開いたときは、ロゴのis-hiddenを外す
          if (logo) {
            logo.classList.remove('is-hidden');
          }
        }
      });
      if (mm.matches) {
        $(menu).removeClass('is-open');
        updateAriaAttributes(false);
      }
      // メディアクエリ変化時
      if (mm.addEventListener) {
        mm.addEventListener('change', mqHandler);
      } else {
        mm.addListener(mqHandler);
      }
      function mqHandler(m) {
        if (m.matches) {
          $(menu).removeClass('is-open');
          $(openBtn).removeClass('is-active');
          document.body.classList.remove('scrollLock');
          $(inner).removeClass('is-scrolled');
          updateAriaAttributes(false);
        } else {
          $(menu).removeClass('is-open');
          $(openBtn).removeClass('is-active');
          document.body.classList.remove('scrollLock');
          $(inner).removeClass('is-scrolled');
          updateAriaAttributes(false);
        }
      }
    });
  }
}
